import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchAttachment, deleteAttachment } from "../../services/common.services";
import { useDataAuth } from "../../hooks/useDataAuth";
import { useNotification } from "../../hooks/useNotification";
import { DownloadFile } from '../others/DownloadFile';
import { useTranslation } from "react-i18next";

export const TableAttachments = ({ attachment, setAttachment, edit, id, isView }) => {
    const { t } = useTranslation();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();

    const handleFileChange = async (event) => {
        const asfile = event.target.files[0];
        const maxSize = 9 * 1024 * 1024;
        if (!asfile || asfile.type !== "application/pdf" || asfile.size > maxSize) {
            sendNotification({
                msg: t("messages.pdfOnlyMaxSize", {
                    type: ".pdf",
                    size: "9MB"
                }),
                variant: "info",
            });
            return;
        }

        const obj = {};
        const reader = new FileReader();
        reader.onload = (e) => {
            const base64String = e.target.result.split(",")[1];
            obj.bytes = base64String
        };
        reader.readAsDataURL(asfile);
        obj.name = asfile.name;
        obj.size = (asfile.size / (1024 * 1024)).toFixed(2);
        obj.added = true;
        setAttachment([...attachment, obj]);
    };

    useEffect(() => {
        if (edit) {
            const fetchFollowedUpBy = async () => {
                const resp = await fetchAttachment({
                    id_user_action: 'MENU-MEETING',
                    id_unique: id
                }, userSession.token);
                if (resp.data && Array.isArray(resp.data))
                    setAttachment(resp.data);
            }
            fetchFollowedUpBy();
        }
    }, [userSession.token, edit]);

    const handleDelete = (item, idx) => {
        setAttachment(prevItems => prevItems.filter((_, index) => index !== idx));
        if (!item?.added) {
            deleteAttachment({
                id_flow: '900114098-FOLLOW_UP_ATTACHMENT_DELETE',
                id: item.id_attachment
            }, userSession.token)
        }
    }

    return (
        <Grid size={{ xs: 12, sm: 12 }} key="attachment">
            <Button variant="contained" disabled={isView} component="label" sx={{
                width: '200px', height: '35px', borderRadius: '8px', textTransform: 'none',
            }}>
                Adjuntar archivo
                <input type="file" hidden onChange={(e) => handleFileChange(e)} />
            </Button>
            <TableContainer
                style={{ height: '35vh', overflow: 'auto', borderBottom: 'solid 1px' }}
            >
                <Table
                    aria-labelledby='tableTitle'
                    size='small'
                    stickyHeader
                >
                    <TableHead>
                        <TableRow sx={{ px: 2 }}>
                            <TableCell
                                align='center'
                                style={{ width: 30 }}
                            >
                            </TableCell>
                            <TableCell
                                key={`tc-Archivo`}
                                align='center'
                            >
                                Archivo
                            </TableCell>
                            <TableCell
                                key={`tc-Tamano`}
                                align='center'
                            >
                                Tamaño
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            Array.isArray(attachment) &&
                            attachment.map((item, idx) => (
                                <TableRow
                                    tabIndex={idx}
                                    key={item.name}
                                >
                                    <TableCell
                                        align='center'
                                        sx={{ display: 'flex' }}
                                    >
                                        <Tooltip title={'Eliminar'}>
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => handleDelete(item, idx)}
                                                sx={{ color: 'red' }}
                                                disabled={isView}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {edit && !item?.added &&
                                            <DownloadFile
                                                path={item?.url}
                                                bucket={item?.bucket}
                                                idFlow={'900114098-API-DOWNLOAD-BASE64'}
                                            />
                                        }
                                    </TableCell>
                                    <TableCell
                                        key={`tc-file`}
                                        padding='normal'
                                        align='center'
                                    >
                                        <Typography>
                                            {item.name}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        key={`tc-zise`}
                                        padding='normal'
                                        align='center'
                                    >
                                        <Typography>
                                            {item.size} MB
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}